export const appConstansts = {
  limit: 24
}
export const commonState = {
  token: null,
  adminToken: null,
  isAdmin: false,
  user: {
    credit: 0,
    personal: {},
    company: {},
    shippingAddress: {},
    shipping: 0,
    payment: 0,
    shippingCost: 0,
    currency: { sign: '€' }
  },
  oz: {},
  profileIsChanged: false,
  shipping: [],
  company: {},
  modals: [],
  mobileSearchBarOpen: false,
  cartOpen: false,
  loginOpen: false,
  lostPassOpen: false,
  filterOpen: true,
  categorySidebarOpen: false,
  loading: false,
  searchLoading: false,
  input: [],
  notifications: [],
  offset: 1,
  lobing: false,
  countries: [],
  manufacturer: [],
  edition: [],
  compatibility: [],
  color: [],
  orderTypes: [],
  flexColors: [],
  loginLoading: false,
  commonLoading: false,
  isLoginModalOpen: false,
  failuredApiCalls: [],
  progressStep: 0,
  salesmenLoading: false,
  salesmen: [],
  orderTypeDropdownOpen: false,
  openOrdersList: [],
  openOrdersLoading: false,
  error: null,
  unavailableItems: [],
  salesLoading: false,
  sales: [],
  isAnyHotProducts: false,
  showingHotsProducts: false,
  dailyHotProducts: 0,
  customerDetail: false,
  tags: {},
}

export const productState = {
  list: [],
  fullList: [],
  filteredList: [],
  inCart: [],
  detail: {},
  filter: [],
  searchBy: null,
  searchList: [],
  sortBy: 'date',
  sortOrder: 'asc',
  lobbedProduct: {},
  loading: false,
  loaded: false,
  loadingMore: false,
  loadingSearch: false
}

export const cartState = {
  list: [],
  toDelete: [],
  note: null,
  availableToImport: false,
  isImporting: false,
  temporalImportedData: [],
  loadingItems: false,
  loadingImport: false,
  dualData: {
    list: [],
    isUploaded: false,
    customerId: null
  }
}

export const categoryState = {
  list: [],
  openedCategory: [],
  active: 0,
  loadingCategories: false,
  news: false
}

export const customerState = {
  list: [],
  actionBarActive: null,
  filter: [],
  searchBy: null,
  searchList: [],
  shortList: [],
  actionOnCustomer: null,
  loading: false,
  loadingTest: false,
  loadingCart: false,
  cart: [],
  topSellingProducts: {
    common: [],
    user: []
  }
}

export const orderState = {
  list: [],
  fullList: [],
  detail: {},
  term: '',
  filter: [],
  sortBy: 'date',
  sortOrder: 'desc',
  rangeFrom: null,
  rangeTo: null,
  orderLoading: false
}



// WEBPACK FOOTER //
// ./src/store/stateModel.js